import Head from 'next/head'
import { FitnessDeals } from '../../../../components/home/deals/FitnessDeals'
import { countryList } from '../../../../utils/constants'
import Script from 'next/script'
import { CommonBanner } from '../../../../components/index/service-category/CommonBanner'
import { downloadAllFitnessPackages } from '../../../../api/personal-trainer/personal-trainer-api'

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps({params}) {
    
    const countryName = "Singapore"
    
    const fitnessDeals =  await downloadAllFitnessPackages("All", countryName, "N", 12, 0, "DESC", "a.recommend_val")

    return {
        props: {
          countryName,
          fitnessDeals
        },
        // Next.js will attempt to re-generate the page:
        // - When a request comes in
        // - At most once every 10 seconds
        revalidate: 259200, // In seconds
    }
}

export default function Home(props) {
  const countryName = props.countryName
  const fitnessDeals = props.fitnessDeals

  return (
    <>
      <Head>
        <title>Personal Training Packages & Deals in Singapore</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description"
            content="Affordable Personal training packages from gyms and fitness trainers in Singapore to help with weight loss, muscle toning and body building."/>
        <meta name="keywords"
            content="Fitness trainer Singapore, personal trainer Singapore, gym Singapore, weight loss Singapore, bodybuilding Singapore,
                    exercise Singapore, personal trainer, lifestyle Singapore, weight loss, fat loss Singapore"/>
        <meta name="author" content="StringsSG - Personal Training"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:url" content={`https://www.stringssg.com/sg/personal-trainer/deals`} />
        <meta property="og:type"   content="website" />
        <meta property="og:title"    content="Personal Training Packages & Deals in Singapore"/>
        <meta property="og:description" content="Affordable Personal training packages from gyms and fitness trainers in Singapore to help with weight loss, muscle toning and body building."/>
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/personal-trainer/personal-trainer-singapore.jpeg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content={`https://www.stringssg.com/sg/personal-trainer/deals`}/>
        <meta name="twitter:title" content="Personal Training Packages & Deals in Singapore"/> 
        <meta name="twitter:description" content="Affordable Personal training packages from gyms and fitness trainers in Singapore to help with weight loss, muscle toning and body building."/> 
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/personal-trainer/personal-trainer-singapore.jpeg" /><link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/sg/personal-trainer/deals" />
      </Head> 
        <div>
            <CommonBanner countryName={countryName} bannerText={"Personal Training Deals & Packages"} category={`personal-trainer`}/>
            <FitnessDeals countryName={countryName} fitnessDeals={fitnessDeals}/>
        </div>
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
        />
        <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
